class InventoryList {
    constructor(hostname, path = '/api') {
        this._api = hostname + path
        this._hostname = hostname
        this._path = path
    }

    get query (){
        return this._api + '/storagequery/getmaterialstocklist'
    }
}

export default InventoryList
